import type { PostHog } from "posthog-js";

let postHog: PostHog | null = null;
let postHogPromise: Promise<PostHog> | null = null;

export function getLoadedPostHog(): PostHog | null {
  return postHog;
}

export function loadPostHog(): Promise<PostHog> {
  if (!postHogPromise) {
    postHogPromise = import("posthog-js")
      .then(({ default: loadedPostHog }) => {
        postHog = loadedPostHog;
        return loadedPostHog;
      })
      .catch((error) => {
        postHogPromise = null;
        throw error;
      });
  }

  return postHogPromise;
}
